import { ClientSlugEnum, StoresSlugEnum, TabsQueryParamsEnum } from 'src/app/enums/assessment.enum';
import { BaseClient } from './base-client';
import { IClientConfig } from './client.inteface';
import { TermsConditionsCourseDialogComponent } from 'src/app/teacher/assessments/my-learnings/buy-courses/terms-conditions-course-dialog/terms-conditions-course-dialog.component';

/**
* IWSA Client Implementation
* Concrete implementation for IWSA client
*/
export class IITEDClient extends BaseClient {
  constructor() {
    const config: IClientConfig = {
      name: 'ii-ted',
      slug: ClientSlugEnum.IITED,
      displayName: 'II-TED',
      // Header
      headerLogo: 'assets/img/logo/ii-ted-logo-blue.svg',
      headerLogoAlt: 'II-TED Logo',
      headerPhone: '+918422887582',
      headerPhoneDisplay: '+91 84228 87582',
      headerEmail: 'contact@iited.com',
      headerSupportEmail: 'contact@iited.com',
      learningHeaderPhone: '+918422887264',
      learningHeaderPhoneDisplay: '+91 84228 87264',
      learningHeaderEmail: 'hubblevleap.support@hubblehox.com',
      learningHeaderSupportEmail: 'hubblevleap.support@hubblehox.com',
      // Hero
      heroLogo: 'assets/img/login-register-logo.svg',
      heroLogoAlt: 'II-TED Logo',
      teacherDashboardRedirectionURL: TabsQueryParamsEnum.MY_ASSESSMENTS,
      teacherSelectedTabIndex: 0,
      isInstitute: true,
      // Footer
      footerEmail: 'contact@hubblehox.com',
      footerSupportEmail: 'contact@hubblehox.com',
      // Dashboard
      dashboardTabs: [
        {
          tabIndex: 0,
          label: 'My Assessments',
          icon: './assets/img/my-assessments-tab-icon.png',
          component: 'app-my-assessments',
          queryParam: TabsQueryParamsEnum.MY_ASSESSMENTS,
          disabled: false,
        },
        {
          tabIndex: 1,
          label: 'My Olympiads',
          icon: './assets/img/teachers-olympiad-tab-icon.svg',
          component: 'app-teachers-olympiad',
          queryParam: TabsQueryParamsEnum.MY_OLYMPIADS,
          disabled: true,
        },
        {
          tabIndex: 2,
          label: 'My Learnings',
          icon: './assets/img/my-learnings-tab-icon.svg',
          component: 'app-my-learnings',
          queryParam: TabsQueryParamsEnum.MY_LEARNINGS,
          disabled: false,
        },
      ],
      myLearningTabStoreSlug: StoresSlugEnum.LEARNINGS,
      myLearningsAssessmentDialogComponent: TermsConditionsCourseDialogComponent,
      myLearningFAQs: [
        {
          title: 'Do I need any prior knowledge of Artificial Intelligence or a technical background to start this course?',
          description: '<span class="grey-text">No, you don’t need any prior knowledge of Artificial Intelligence or a technical background.</span>',
          expandImgSrc: 'assets/img/plus-icon.png',
          collapseImgSrc: 'assets/img/minus-icon.png',
        },
        {
          title: 'How should I plan my time to complete all three modules effectively?',
          description: '<span class="grey-text">This is a self-paced course. You can schedule dedicated study hours in your calendar for about three hours a week. You should aim to complete one module each month to maintain steady progress. Although <span class="highlight-text">the maximum allowed duration is six months, it is more advantageous to complete all three modules within three months.</span></span>',
          expandImgSrc: 'assets/img/plus-icon.png',
          collapseImgSrc: 'assets/img/minus-icon.png',
        },
        {
          title: 'Are the AI tools demonstrated in the course free to use, or will I need paid subscriptions?',
          description: '<span class="grey-text">The AI tools showcased use a <span class="highlight-text">freemium model, giving users access to a range of features at no cost</span> while reserving advanced features for paid subscribers. A thorough comparison of the tools detailed in the resources (PDF and videos) highlights the distinction between free and premium features, helping you make informed decisions that align with your needs.</span>',
          expandImgSrc: 'assets/img/plus-icon.png',
          collapseImgSrc: 'assets/img/minus-icon.png',
        },
        {
          title: 'Will I get hands-on practice with tools like ChatGPT, Gemini, or other LLMs during the course?',
          description: '<span class="grey-text">The course resources offer in-depth insights and comprehensive step-by-step guidance on effectively utilising LLM and AI platforms. You can use the ready-made prompts and rubrics for hands-on practice at your convenience.</span>',
          expandImgSrc: 'assets/img/plus-icon.png',
          collapseImgSrc: 'assets/img/minus-icon.png',
        },
        {
          title: 'What are the requirements for course certification?',
          description: '<span class="grey-text">You must complete the module-level and course-level tests and submit all required practicums to receive the certification. All module- and course-level tests can be attempted up to 3 times.</span>',
          expandImgSrc: 'assets/img/plus-icon.png',
          collapseImgSrc: 'assets/img/minus-icon.png',
        },
        {
          title: 'When and how will I receive my certificate after completing all modules and assessments?',
          description: '<span class="grey-text">On successful completion of tests and practicums, you can download <span class="highlight-text">the certificate from the LMS.</span></span>',
          expandImgSrc: 'assets/img/plus-icon.png',
          collapseImgSrc: 'assets/img/minus-icon.png',
        },
      ]
      // My-Cart
    };
    super(config);
  }
}